import {
    ADULT_BADGE_ATTRIBUTE,
    ADULT_VERIFIED_UI_CLASS,
} from "../../Adult/constants";

const EDIT_CLASSES = ['solid-blue', 'solid-light-blue', 'dashed-blue', 'dashed-grey', 'border-invalid-action'];

export function getCleanHtml(element: HTMLElement): string {
    const clone = element.cloneNode(true) as HTMLElement;
    clone.classList.remove(ADULT_VERIFIED_UI_CLASS);
    clone.querySelectorAll('.system-text').forEach(el => el.remove());
    clone.querySelectorAll(EDIT_CLASSES.map(c => `.${c}`).join(',')).forEach(el => {
        EDIT_CLASSES.forEach(cls => el.classList.remove(cls));
    });
    clone.querySelectorAll(`[${ADULT_BADGE_ATTRIBUTE}="true"]`).forEach((el) => {
        (el as HTMLElement).style.removeProperty("display");
    });
    return clone.innerHTML;
}
